module.exports = __webpack_public_path__ + "img/ico-consumos-b.3c266faa.svg";